import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Company: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2008 11.271L15 10V20C15 20.5523 15.4477 21 16 21H21C21.5523 21 22 20.5523 22 20V12.2506C22 11.7757 21.666 11.3663 21.2008 11.271Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M2 3.1745V22C2 22.5523 2.44772 23 3 23H4.80176C5.35404 23 5.80176 22.5523 5.80176 22V18.7C5.80176 17.5954 6.69719 16.7 7.80176 16.7H9.76346C10.868 16.7 11.7635 17.5954 11.7635 18.7V22C11.7635 22.5523 12.2112 23 12.7635 23H14C14.5523 23 15 22.5523 15 22V4.95142C15 4.4607 14.6439 4.04248 14.1595 3.96422L3.15947 2.1873C2.55143 2.08908 2 2.55858 2 3.1745Z"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="17" y="13" width="3" height="2" rx="1" fill={color} />
      <rect x="4" y="6" width="3" height="2" rx="1" fill={color} />
      <rect x="17" y="15.739" width="3" height="2" rx="1" fill={color} />
      <rect x="4" y="9" width="3" height="2" rx="1" fill={color} />
      <rect x="4" y="12" width="3" height="2" rx="1" fill={color} />
      <rect x="8" y="6" width="4" height="2" rx="1" fill={color} />
      <rect x="8" y="9" width="4" height="2" rx="1" fill={color} />
      <rect x="8" y="12" width="4" height="2" rx="1" fill={color} />
    </svg>
  );
};

export default Company;
